import React, { FC } from 'react';

const NesTitle: FC = ({ children }) => (
  <p className='title'>{ children }</p>
);

export default NesTitle;